module.exports = __webpack_public_path__ + "krecove-zily_6_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/krecove-zily_6_before.jpg
// module id = 1036
// module chunks = 0